import React from "react";
import { Row, Col, Pagination } from "antd";
import { VIEW_ACCOMODATION } from "../../app/apollo/index";
import { useLazyQuery } from "@apollo/client";
import { TextInput } from "../../globalComponents/TextInput";
import { LoggerButton } from "../../globalComponents/Button";
import { ServiceCard } from "../Services/Styles";
import { useHistory } from "react-router-dom";
import { IoIosFunnel } from "react-icons/io";
import { MdCall } from "react-icons/md";
import { BigContentContainer, Label } from "../../globalComponents/globalStyle";
import { IoLocation } from "react-icons/io5";
import { FilterContainer, MobileFilter } from "./style";
import { Text } from "../Education/style";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { userInfo } from "../../globalComponents/slice/userDataSlice";
import { useAppSelector } from "../../app/hooks";

import { StyledDrawer } from "../../globalComponents/AppLayout";

const Acommodation: React.FC = () => {
  const history = useHistory();
  const userDetails = useAppSelector(userInfo);
  const [defaultCountry, setDefaultCountry] = React.useState();
  const [drawerVisible, setDrawerVisible] = React.useState(false);
  const [loadingState, setLoading] = React.useState(false);
  const [accomodation, setAccommodation] = React.useState([]);
  const [country, setCountry] = React.useState("");
  const [city, setCity] = React.useState("");
  const [bedRoom, setBedRoom] = React.useState("");
  const [minPrice, setMinPrice] = React.useState("");
  const [maxPrice, setMaxPrice] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState<any>(1);
  const [allPages, setAllPages] = React.useState<any>();

  const [filterAccommodations, filterAccommodationsData] =
    useLazyQuery(VIEW_ACCOMODATION);
  React.useEffect(() => {
    if (filterAccommodationsData?.error) {
      setLoading(false);
      setAccommodation([]);
      NotificationAlert("error", "Error occured", "Try Again");
    } else if (filterAccommodationsData?.data?.filterAccommodations) {
      setLoading(false);
      setAllPages(
        filterAccommodationsData?.data?.filterAccommodations?.last_page
      );
      setAccommodation(
        filterAccommodationsData?.data?.filterAccommodations?.listing
      );
      setDrawerVisible(false);
    } else if (filterAccommodationsData?.loading === true) {
      setLoading(true);
    }
  }, [filterAccommodationsData]);
  React.useEffect(() => {
    handleSearch(
      defaultCountry,
      city,
      minPrice,
      maxPrice,
      bedRoom,
      currentPage
    );
  }, [defaultCountry]);
  React.useEffect(() => {
    setDefaultCountry(userDetails?.currentCountry?.country);
  }, [userDetails]);
  const handleSearch = async (
    byCountry: any,
    byCity: any,
    byMinAmount: any,
    byMaxAmount: any,
    byTotalBedRoom: any,
    current: number
  ) => {
    setAccommodation([]);
    try {
      filterAccommodations({
        variables: {
          byCountry: byCountry,
          byArea: byCity,
          byMinPrice: byMinAmount,
          byMaxPrice: byMaxAmount,
          byTotalBedRoom: +byTotalBedRoom,
          requestedPage: current,
          byListingType: "rent",
        },
      });
    } catch (e) {
      console.log(e);
    }
  };
  console.log("accomodation data", filterAccommodationsData);
  const handleBackChange = () => {
    if (currentPage > 1) {
      handleSearch(country, city, minPrice, maxPrice, bedRoom, currentPage - 1);
      setCurrentPage(currentPage - 1);
    }
  };
  const handleForwardChange = () => {
    if (currentPage < allPages) {
      handleSearch(country, city, minPrice, maxPrice, bedRoom, currentPage + 1);
      setCurrentPage(currentPage + 1);
    }
  };
  function itemRender(current?: any, type?: any, originalElement?: any) {
    if (type === "prev") {
      return (
        <h5 style={{ color: "blue", margin: 0 }} onClick={handleBackChange}>
          Previous
        </h5>
      );
    }
    if (type === "next") {
      return (
        <h5 style={{ color: "blue", margin: 0 }} onClick={handleForwardChange}>
          Next
        </h5>
      );
    }
    return originalElement;
  }
  const list = (
    <Row>
      {accomodation?.map((accomodation: any, id: any) => (
        <Col
          onClick={() =>
            history.push({
              pathname: `/home/accomodation/details`,
              state: { accomodation },
            })
          }
          key={id}
          style={{ marginBottom: "15px" }}
          xs={{ span: 24 }}
          md={{ span: 12 }}
        >
          <ServiceCard>
            {/* <div>
              <IDAvatar>{accomodation?.address?.locationName}</IDAvatar>
              <h5 className="title-medium">{accomodation?.name}</h5>
            </div> */}

            <div style={{ display: "flex" }}>
              <img
                src={
                  accomodation?.images[0] ||
                  `https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80`
                }
                alt="house"
              />
              <div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "10px",
                    alignItems: "baseline",
                    padding: " 0 0 0 10px",
                  }}
                >
                  <IoLocation style={{ margin: 0 }} />
                  <h4 className="title-medium">
                    {accomodation?.displayable_address}
                  </h4>
                </div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "10px",
                    alignItems: "baseline",
                    padding: " 0 0 0 10px",
                  }}
                >
                  <MdCall style={{ margin: 0 }} />
                  <h4 className="title-medium">
                    {accomodation?.agent_phone} Price: {accomodation?.currency}
                    {accomodation?.rental_prices?.per_week / 100}
                  </h4>
                  {/* <h4 style={{ textTransform: "lowercase" }}>
                    currency: {accomodation?.price?.currency}{" "}
                  </h4> */}
                </div>
              </div>
            </div>
          </ServiceCard>
        </Col>
      ))}
    </Row>
  );
  return (
    <BigContentContainer>
      <StyledDrawer
        bodyStyle={{ padding: "0px" }}
        closable={false}
        onClose={() => setDrawerVisible(false)}
        visible={drawerVisible}
        placement="right"
        key="bottom"
      >
        <FilterContainer style={{ height: "100%", display: "block" }}>
          <div>
            <h3>Filter accom. by</h3>
            <Label>
              <h3> General input</h3>
            </Label>
            <TextInput
              placeholder="Type any search name here..."
              onChange={(e: any) => setCity(e.target.value)}
            />
            <br />
            <Label>Country</Label>
            {/* <DropDown
                values={options}
                onChange={(e) => setCountry(e.target.value)}
              /> */}
            <TextInput
              placeholder="Type country name here..."
              onChange={(e: any) => setCountry(e.target.value)}
            />
            <br />
            <Row justify="space-between">
              <Col span={11}>
                <Label>
                  <h3>Min Price</h3>
                </Label>
                <TextInput
                  type="number"
                  placeholder="Amount"
                  onChange={(e: any) => setMinPrice(e.target.value)}
                />
              </Col>
              <Col span={12}>
                {" "}
                <Label>
                  <h3> Max price</h3>
                </Label>
                <TextInput
                  type="number"
                  placeholder="Amount"
                  onChange={(e: any) => setMaxPrice(e.target.value)}
                />
              </Col>
            </Row>

            <br />
            <Label>
              <h3>Total Bedroom </h3>
            </Label>
            <TextInput
              type="number"
              placeholder="Type service name here..."
              onChange={(e: any) => setBedRoom(e.target.value)}
            />
            <br />
            <LoggerButton
              loading={loadingState}
              onClick={() =>
                handleSearch(
                  country,
                  city,
                  minPrice,
                  maxPrice,
                  bedRoom,
                  currentPage
                )
              }
              text="Search.."
            />
          </div>
        </FilterContainer>
      </StyledDrawer>
      <Text>you can search through our list of accomodations...</Text>
      <MobileFilter onClick={() => setDrawerVisible(true)}>
        search for acc.
        <div>
          <IoIosFunnel />
        </div>
      </MobileFilter>
      {loadingState && <Text>loading... please wait</Text>}{" "}
      {/* <h1>Accomodation</h1> */}
      <Row style={{ height: "100%" }} justify="space-between">
        {/* {getService} */}

        <Col md={{ span: 18 }}>
          {accomodation?.length < 1 && !loadingState && (
            <h5 style={{ color: "grey" }}>No accomodation found</h5>
          )}
          {accomodation?.length > 0 && list}
          {accomodation?.length > 0 && (
            <Pagination
              style={{ marginBottom: "10vh" }}
              current={currentPage}
              total={allPages}
              pageSize={1}
              defaultPageSize={allPages}
              showSizeChanger={false}
              itemRender={itemRender}
              showTotal={(total) => `Total: ${total} list`}
            />
          )}
        </Col>
        <Col md={{ span: 5 }}>
          <FilterContainer>
            <div>
              <h3>Filter accom. by</h3>

              <Label>
                <h3> General input</h3>
              </Label>
              <TextInput
                placeholder="Type any search name here..."
                onChange={(e: any) => setCity(e.target.value)}
              />
              <br />
              <Label>Country</Label>
              {/* <DropDown
                values={options}
                onChange={(e) => setCountry(e.target.value)}
              /> */}
              <TextInput
                placeholder="Type country name here..."
                onChange={(e: any) => setCountry(e.target.value)}
              />
              {/* <br />
              <Label>
                <h3> Area</h3>
              </Label>
              <TextInput
                placeholder="Type area name here..."
                onChange={(e: any) => setCity(e.target.value)}
              /> */}
              <br />
              <Row justify="space-between">
                <Col span={11}>
                  <Label>
                    <h3>Min Price</h3>
                  </Label>
                  <TextInput
                    type="number"
                    placeholder="Amount"
                    onChange={(e: any) => setMinPrice(e.target.value)}
                  />
                </Col>
                <Col span={12}>
                  {" "}
                  <Label>
                    <h3> Max price</h3>
                  </Label>
                  <TextInput
                    type="number"
                    placeholder="Amount"
                    onChange={(e: any) => setMaxPrice(e.target.value)}
                  />
                </Col>
              </Row>

              <br />
              <Label>
                <h3>Total Bedroom </h3>
              </Label>
              <TextInput
                type="number"
                placeholder="Enter total bedroom"
                onChange={(e: any) => setBedRoom(e.target.value)}
              />
              <br />
              <LoggerButton
                loading={loadingState}
                onClick={() =>
                  handleSearch(
                    country,
                    city,
                    minPrice,
                    maxPrice,
                    bedRoom,
                    currentPage
                  )
                }
                text="Search.."
              />
            </div>
          </FilterContainer>
        </Col>
      </Row>
    </BigContentContainer>
  );
};

export default Acommodation;
